export default __webpack_public_path__ + "static/careGiver-29f0155284fa287942535ec51dacb94b.jpg";